<template>
  <WithLoader id="block-usages" class="flex flex-col" :loading="isLoading" use-as-overlay>
    <div class="flex pb-5 border-solid border-b border-0 border-soft">
      <span class="my-auto py-1 ml-6">
      <base-button variant="transparent-primary"
                   icon="keyboard_arrow_left"
                   @click="hideTemplateUsages"></base-button>
      </span>

      <span class="my-auto px-4 ml-4 border-solid border-l-2 border-0 border-soft text-gray-dark" v-html="summaryText"></span>
    </div>

    <div class="flex flex-col gap-5 mt-10">
      <div v-if="usedInAnswer">
        <div class="flex flex-row items-center text-gray-dark ml-6">
          <span class="text-lg font-bold ml-px">Answers</span>
          <AnswersIcon class="ml-2 h-5" />
        </div>

        <UsagesList :botId="botId" :list="answersUsageList" />
      </div>

      <div v-if="usedInEvent">
        <div class="flex flex-row items-center text-gray-dark ml-6">
          <span class="text-lg font-bold ml-px">Events</span>
          <EventsIcon class="ml-2 h-5" />
        </div>

        <UsagesList :botId="botId" :list="eventsUsageList" />
      </div>
    </div>
  </WithLoader>
</template>

<script>
import templateModule from '@/store/modules/template.module'
import templateService from '@/services/amio/template.service'
import eventService from '@/services/amio/event.service'
import UsagesList from './UsagesList'
import WithLoader from '@/components/common/WithLoader'
import AnswersIcon from '@/assets/images/icons/AnswersIcon'
import EventsIcon from '@/assets/images/icons/EventsIcon'
import isEmpty from 'ramda/src/isEmpty'
import { ROUTE_NAMES } from '@/router'

export default {
  name: 'TemplateUsages',
  components: { UsagesList, WithLoader, AnswersIcon, EventsIcon },

  props: {
    botId: {
      type: String,
      required: true
    },
    templateId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isLoading: false,
      answers: [],
      events: [],
      dbEvents: []
    }
  },

  computed: {
    usedInAnswer() {
      return !isEmpty(this.answers)
    },

    usedInEvent() {
      return !isEmpty(this.events)
    },

    summaryText() {
      if (!this.usedInAnswer && !this.usedInEvent) {
        return 'The block is currently unused'
      }

      const summaryStrings = ['The block is used in']
      if (this.usedInAnswer) {
        const answerCount = this.answers.length
        summaryStrings.push(`<strong>${answerCount} ${answerCount > 1 ? 'Answers' : 'Answer'}</strong>`)
      }

      if (this.usedInEvent) {
        if (this.usedInAnswer) {
          summaryStrings.push('and')
        }
        const eventCount = this.events.length
        summaryStrings.push(`<strong>${eventCount} ${eventCount > 1 ? 'Events' : 'Event'}</strong>`)
      }

      return summaryStrings.join(' ')
    },

    answersUsageList() {
      return this.answers.map(answer => {
        return {
          title: answer.name,
          subtitle: '',
          routeDetails: {
            name: ROUTE_NAMES.answers,
            params: {
              botId: this.botId,
              answerId: answer.id
            }
          }
        }
      })
    },

    eventsUsageList() {
      return this.events.map(event => {
        const dbEvent = this.getDbEvent(event.id)
        return {
          title: dbEvent.name,
          subtitle: dbEvent.description,
          routeDetails: {
            name: ROUTE_NAMES.events,
            params: {
              botId: this.botId,
              eventId: dbEvent.id
            }
          }
        }
      })
    }
  },

  methods: {
    hideTemplateUsages() {
      templateModule.hideUsages()
    },

    getDbEvent(eventId) {
      return this.dbEvents.find(event => event.id === eventId)
    }
  },

  async mounted() {
    this.isLoading = true
    this.dbEvents = await eventService.list(this.botId)
    const { answers, events } = await templateService.listRefs(this.botId, this.templateId)
    this.answers = answers
    this.events = events
    this.isLoading = false
  },

  destroyed() {
    this.hideTemplateUsages()
  }
}
</script>
